import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import UsageTracker from '../../../utils/UsageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CreatePlaylistModalTrigger from './CreatePlaylistModalTrigger';
import { jsx as _jsx } from "react/jsx-runtime";
const CardMenuAddToNewPlaylistOption = ({
  item
}) => {
  return /*#__PURE__*/_jsx(CreatePlaylistModalTrigger, {
    item: item,
    renderTrigger: ({
      openModal
    }) => /*#__PURE__*/_jsx(SideNavItem, {
      onClick: () => {
        UsageTracker.track('playlistInteraction', {
          action: 'add-to-new-playlist',
          location: 'card-menu',
          itemId: item.id,
          itemType: item.type
        });
        openModal();
      },
      role: "navigation-item",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.cardMenu.addToNewPlaylist"
      })
    })
  });
};
export default CardMenuAddToNewPlaylistOption;